import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import FlightDetailsWidgetDesktop from './FlightDetailsWidgetDesktop.js'
import FlightDetailsWidgetMobile from './FlightDetailsWidgetMobile.js'

const LoadingWrapper = styled.div`
  width: 100%;
  height: 300px;
`

export const FlightDetailsView = ({ widgetState, onCloseClicked, isDesktop: isDesktopFn, onGetDirectionClick, Loading, bus, T, id }) => {
  const [state, setState] = useState(widgetState.getState())
  useEffect(() => widgetState.addCallback(setState))

  if (state.loadingFlightInfo) return <LoadingWrapper><Loading /></LoadingWrapper>

  const isDesktop = isDesktopFn()

  return isDesktop
    ? <FlightDetailsWidgetDesktop state={state}
      T={T}
      onGetDirectionClick={onGetDirectionClick}
      onCloseClicked={onCloseClicked} />
    : <FlightDetailsWidgetMobile id={id} state={state}
      T={T}
      bus={bus}
      onGetDirectionClick={onGetDirectionClick}
      onCloseClicked={onCloseClicked}/>
}
